import { Card, Grid, Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import EmptyComponent from "../../../utils/EmptyComponent";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import Button from "../../../toolkit/ButtonV1";
import Visibility from "@mui/icons-material/Visibility";

import TemplateSectionList from "./TemplateSectionList";
import CollectionsTemplate from "../../../components/CollectionsTemplate";

import { fontSize } from "@mui/system";
import axios from "../../../utils/fvAxios";
import BaseUrl from "../../../utils/base-uri.json";

function templatesSectionsDataAdaptor(data) {
  return {
    headers: [
      { id: "sectionsName", text: "", width: "60%" },
      { id: "Action", text: "", width: "40%" },
    ],
    isEditable: {
      callback: (item) => {},
      isVisible: false,
    },
    isDeletable: {
      callback: (item) => {},
      isVisible: false,
    },
    rows: data?.map((d, i) =>
      Object.assign({}, d, {
        key: d.templateSectionId,
      })
    ),
  };
}

export default function TemplateItem({
  status,
  headers = [],
  statusRoleMap,
  templateName,
  templateId,
  clientName,
  templateSections,
  ...props
}) {
  const [expanded, setExpanded] = useState(false);
  const [allowReorder, setAllowReorder] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [collection, setCollection] = useState({});
  const [temporarycollection, setTemporaryCollection] = useState([]);

  useEffect(() => {
    if (templateSections) {
      setCollection(templatesSectionsDataAdaptor(templateSections));
    }
  }, [templateSections]);

  const SaveReorder = () => {
    setAllowReorder(false);
    setCollection(temporarycollection);
    axios
      .post(BaseUrl.templateTool.ReorderTemplateSections, temporarycollection?.rows)
      .then((response) => {});
  };

  const cancelReoder = () => {
    setAllowReorder(false);
    setTemporaryCollection([]);
  };

  const reOrderedData = (data) => {
    setTemporaryCollection(templatesSectionsDataAdaptor(data));
  };

  return (
    <>
      <Accordion
        TransitionProps={{ unmountOnExit: true }}
        className=""
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel1a-content-${templateId}`}
          //id={`panel1a-header-${idx}`}
          className="border-bottom"
        >
          <div>
            <span className="d-block"> <Visibility color="disabled" className="me-2" /> {templateName}</span>
            <span className="d-block text-muted my-1" style={{ fontSize: "0.8rem" }}>
             for {clientName}
            </span>
          </div>
        </AccordionSummary>
        <AccordionDetails className="px-0 border-bottom">
       
            <Box
              className="mt-3"
              style={{ padding: "16px" }}
              sx={{ "& h1": { m: 0 } }}
            >
              <Grid
                container
                wrap="nowrap"
                sx={{
                  flexDirection: { xs: "column", md: "row", oveflow: "auto" },
                }}
                spacing={1}
                justify="flex-start"
              >
                <Grid item sx={{ margin: "auto" }}>
                  <Grid
                    container
                    className="text-align-center"
                    wrap="nowrap"
                    sx={{
                      flexDirection: {
                        xs: "column",
                        md: "row",
                        overflow: "auto",
                      },
                    }}
                    spacing={1}
                  >
                    {allowReorder ? (
                      <>
                        <Grid item>
                          <Button
                            sx={{ minWidth: "130px" }}
                            role="secondary"
                            size="large"
                            label="Cancel"
                            onClick={cancelReoder}
                          />
                        </Grid>
                        <Grid item>
                          <Button
                            sx={{ minWidth: "130px" }}
                            role="secondary"
                            size="large"
                            label="Done"
                            onClick={SaveReorder}
                          />
                        </Grid>
                      </>
                    ) : (
                      <Grid item>
                        <Button
                          sx={{ minWidth: "130px" }}
                          role="secondary"
                          size="large"
                          label="Re-Arrange"
                          onClick={() => {
                            setTemporaryCollection(collection);
                            setAllowReorder(true);
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <Link
                        to={`/checklists?t=${templateId}`}
                        style={{
                          textTransform: "capitalize",
                          textDecoration: "none",
                          color: "rgb(97, 169, 251)",
                        }}
                      >
                        <Button
                          sx={{ minWidth: "130px" }}
                          role="primary"
                          size="large"
                          label="View Checklist"
                        />
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          
          <Box>
            {expanded && (
              <CollectionsTemplate
                TitlebarChildren={EmptyComponent}
                collection={collection}
                viewType={"list"}
                responseDataAdaptor={templatesSectionsDataAdaptor}
                ListItemComponent={TemplateSectionList}
                GridItemComponent={EmptyComponent}
                SlidingPopupTitle="Sections Filters"
                SlidingPopupContent={<EmptyComponent />}
                isReodering={allowReorder}
                fetchState={{ isLoading: false }}
                reOrderedData={reOrderedData}
              />
            )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}
